import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  locationTree: [],
  townCouncils: [],
  isLoadingTownCouncils: false,
  tcDetails: {},
  isLoadingTcDetails: false,
  isLoading: false,
  error: null,
};

export const getTownCouncils: any = createAsyncThunk(
  "content/getTownCouncils",
  async (params) => {
    const res = await axios.get(`/slpapp/TC/getall`, {
      params: params,
    });

    const data = await res.data;

    return data;
  }
);

export const getAllLocationTree: any = createAsyncThunk(
  "content/getAllLocationTree",
  async (params) => {
    const res = await axios.get(`/slpapp/TC/getAllLocation`, {
      params: params,
    });

    const data = await res.data;
    return data;
  }
);

export const getTCByCode: any = createAsyncThunk(
  "content/getTCByCode",
  async ({ tcCode }: any) => {
    const res = await axios.get(`/slpapp/TC/tcbycode`, {
      params: { tcCode },
    });

    const data = await res?.data?.data;
    return data;
  }
);

export const addTC: any = createAsyncThunk(
  "content/addUser",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/TC`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const editTC: any = createAsyncThunk(
  "content/editUser",
  async ({ payload, tcCode }: any) => {
    const res = await axios.put(`/slpapp/TC`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { tcCode },
    });

    const data = await res.data;
    return data;
  }
);

export const deleteTC: any = createAsyncThunk(
  "content/deleteUser",
  async ({ tcCode }: any) => {
    const res = await axios.delete(`/slpapp/TC`, {
      params: { tcCode },
    });

    const data = await res.data.data;
    return data;
  }
);

export const townCouncilSlice = createSlice({
  name: "townCouncil",
  initialState,
  reducers: {
    setTCOptionsData(state, action) {
      state.townCouncils = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTownCouncils.pending, (state) => {
      state.isLoadingTownCouncils = true;
    });
    builder.addCase(getTownCouncils.fulfilled, (state, action) => {
      state.isLoadingTownCouncils = false;
      state.townCouncils = action.payload;
    });
    builder.addCase(getTownCouncils.rejected, (state, action) => {
      state.isLoadingTownCouncils = false;
      state.error = action.error.message;
    });

    builder.addCase(getAllLocationTree.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllLocationTree.fulfilled, (state, action) => {
      state.isLoading = false;
      state.locationTree = action.payload;
    });
    builder.addCase(getAllLocationTree.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getTCByCode.pending, (state) => {
      state.isLoadingTcDetails = true;
    });
    builder.addCase(getTCByCode.fulfilled, (state, action) => {
      state.isLoadingTcDetails = false;
      state.tcDetails = action.payload;
    });
    builder.addCase(getTCByCode.rejected, (state, action) => {
      state.isLoadingTcDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(addTC.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addTC.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addTC.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteTC.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteTC.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteTC.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editTC.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editTC.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editTC.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { setTCOptionsData } = townCouncilSlice.actions;

export default townCouncilSlice.reducer;
